var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSea6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96456 13C7.72194 14.6961 6.26324 16 4.5 16C2.73676 16 1.27806 14.6961 1.03544 13H0V1C0 0.44772 0.44772 0 1 0H15C15.5523 0 16 0.44772 16 1V3H19L22 7.0557V13H19.9646C19.7219 14.6961 18.2632 16 16.5 16C14.7368 16 13.2781 14.6961 13.0354 13H7.96456ZM14 2H2V10.0505C2.63526 9.4022 3.52066 9 4.5 9C5.8962 9 7.10145 9.8175 7.66318 11H13.3368C13.5045 10.647 13.7296 10.3264 14 10.0505V2ZM16 8H20V7.715L17.9917 5H16V8ZM16.5 14C17.1531 14 17.7087 13.5826 17.9146 13C17.9699 12.8436 18 12.6753 18 12.5C18 11.6716 17.3284 11 16.5 11C15.6716 11 15 11.6716 15 12.5C15 12.6753 15.0301 12.8436 15.0854 13C15.2913 13.5826 15.8469 14 16.5 14ZM6 12.5C6 11.6716 5.32843 11 4.5 11C3.67157 11 3 11.6716 3 12.5C3 12.6753 3.03008 12.8436 3.08535 13C3.29127 13.5826 3.84689 14 4.5 14C5.15311 14 5.70873 13.5826 5.91465 13C5.96992 12.8436 6 12.6753 6 12.5Z",
    fill: "#416EB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea6);
export default __webpack_public_path__ + "static/media/sea-6.62c948976c82be431ac87e750fb4db3b.svg";
export { ForwardRef as ReactComponent };